var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "addToWishList",
      staticClass: "btn btn-link btn-sm text-muted",
      attrs: { "data-toggle": "tooltip", "data-placement": "top" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      _c(
        "svg",
        {
          class: { active: _vm.isVariationInWishList },
          attrs: { width: "16", height: "16", fill: "currentColor" },
        },
        [_c("use", { attrs: { "xlink:href": "#single-wishlist" } })]
      ),
      _vm._v("\n\t\t" + _vm._s(_vm.tooltipText) + "\n    "),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }